import angular from 'angular';

import Component from './enum-builder.component';

const EnumBuilderModule = angular
    .module('control-room.commons.form.components.enum-builder', [])
    .component('crEnumBuilder', Component);

export default EnumBuilderModule;
